// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amateurradio__acma-invible-button {
  visibility: hidden;
}

.amateurradio__acma-upload-button {
  width: 270px;
}

.amateurradio__acma-download-button {
  margin-bottom: 5px;
}

.amateurradio__acma-split-button {
  margin-bottom: 5px;
  width: 100%;
  min-height: 42px;
}
.amateurradio__acma-split-button button {
  font-size: 12px !important;
}

@media only screen and (max-width: 900px) {
  .amateurradio__acma-upload-button {
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./client/styles/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAEF;AADE;EACE,0BAAA;AAGJ;;AAAA;EACE;IACE,UAAA;EAGF;AACF","sourcesContent":[".acma-invible-button {\r\n  visibility: hidden;\r\n}\r\n\r\n.acma-upload-button {\r\n  width: 270px;\r\n}\r\n.acma-download-button {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.acma-split-button {\r\n  margin-bottom: 5px;\r\n  width: 100%;\r\n  min-height: 42px;\r\n  button {\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n@media only screen and (max-width: 900px) {\r\n  .acma-upload-button {\r\n    width: 90%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"acma-invible-button": `amateurradio__acma-invible-button`,
	"acma-upload-button": `amateurradio__acma-upload-button`,
	"acma-download-button": `amateurradio__acma-download-button`,
	"acma-split-button": `amateurradio__acma-split-button`
};
export default ___CSS_LOADER_EXPORT___;
